/* eslint-disable camelcase */
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Redirect } from "react-router-dom";
import { getUserByToken } from "actions/user";
import omit from "lodash/omit";
import PropTypes from "prop-types";
import qs from "qs";
import limitationsSelector from "selectors/limitations";

import { DataStorage } from "utils";
import { getUrlParams } from "utils/urlParams";

export const isAuthenticated = () =>
  DataStorage.getUserEmail() !== null && DataStorage.getUserToken() !== null;

export const LimitationsContext = React.createContext([]);

export const Authenticated = ({ children, history, limitations, location, onGetUser }) => {
  const target = location.pathname;
  if (
    target.startsWith("/settings/subscriptions") ||
    target.startsWith("/flyers") ||
    target.startsWith("/proposals") ||
    target.startsWith("/companies") ||
    target.startsWith("/signup")
  )
    return null;

  const parsed = getUrlParams();
  const { authentication_token, impersonate_token, invite_token } = parsed;
  const token = invite_token || impersonate_token || authentication_token;
  const isImpersonating = !!impersonate_token;
  const newPath = qs.stringify(
    omit(parsed, ["email", "invite_token", "impersonate_token", "authentication_token"])
  );
  const newTarget = `${target}?${newPath}`;
  if (token) {
    history.replace(newTarget);
    onGetUser(parsed.email, token, newTarget, isImpersonating);
  }

  let body = null;
  if (
    !isAuthenticated() &&
    !token &&
    !(
      target.endsWith("/login") ||
      target.endsWith("/reset_password") ||
      target.endsWith("/oauth/linkedin")
    )
  ) {
    body = <Redirect to={`/login?redirect=${newTarget}`} />;
  } else if (isAuthenticated()) {
    body = children;
  }

  return <LimitationsContext.Provider value={limitations}>{body}</LimitationsContext.Provider>;
};

Authenticated.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  onGetUser: PropTypes.func.isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }),
  limitations: PropTypes.arrayOf(PropTypes.string),
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }),
};

const mapStateToProps = (state) => ({
  limitations: limitationsSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  onGetUser: (email, token, target, isImpersonating) => {
    DataStorage.clear();
    DataStorage.setImpersonating(isImpersonating);
    dispatch(getUserByToken(email, token, target));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Authenticated));
